var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileyNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 55.4615385,
    y1: 32.5,
    x2: 67,
    y2: 28,
    id: "Line-3",
    stroke: "#584139",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4BF48",
    cx: 41,
    cy: 41,
    r: 41
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F7D34D",
    cx: 38,
    cy: 40.5,
    rx: 38,
    ry: 37.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#584139",
    cx: 63,
    cy: 28,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#584139",
    cx: 19,
    cy: 28,
    r: 5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57,64 C54.9026036,60.9303692 53.2056339,58.9065597 51.9090909,57.9285714 C50.675634,56.9981693 50.7600217,56.8483343 49.3636364,56.1428571 C46.2272735,54.5583145 42.6558893,54 41,54 C38.7129113,54 34.5764258,54.4558694 30.8181818,57.2142857 C29.4285817,58.2342024 27.4891877,60.4961071 25,64",
    id: "Line-4",
    stroke: "#3D3C3C",
    strokeWidth: 3,
    strokeLinecap: "square",
    transform: "translate(41.000000, 59.000000) scale(1, -1) translate(-41.000000, -59.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyNormal);
export default __webpack_public_path__ + "static/media/Smiley_normal.f70cd9cfea4334a077eec0739df855f5.svg";
export { ForwardRef as ReactComponent };